module.exports = __webpack_public_path__ + "static/media/AX.4adfbc11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AX.svg
// module id = 196
// module chunks = 0